module.exports = ".season-events__container .season-events__button {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1.5em 0 0; }\n\n.season-events__container .season-event__text {\n  word-break: break-word;\n  hyphens: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/season-events/season-events.component.scss
// module id = tbR7
// module chunks = 12